import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";

const isFirebaseEnvDefined = [
  process.env.REACT_APP_FIREBASE_API_KEY,
  process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  process.env.REACT_APP_FIREBASE_PROJECT_ID,
  process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  process.env.REACT_APP_FIREBASE_APP_ID,
  process.env.REACT_APP_FIREBASE_VAPID_KEY,
].every(Boolean);

export const FIREBASE_VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY;

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

let messaging = null;
let app = null;

if (isFirebaseEnvDefined) {
  app = initializeApp(firebaseConfig);

  if (navigator.serviceWorker) {
    messaging = getMessaging(app);
  }
} else {
  console.warn("Firebase environment variables are missing. Firebase messaging will not be initialized.");
}

export const generateToken = async () => {
  if (messaging && navigator.serviceWorker) {
    try {
      const permission = await Notification.requestPermission();
      // console.log(permission);

      if (permission === 'granted') {
        const token = await getToken(messaging, {
          vapidKey: FIREBASE_VAPID_KEY
        });
        // console.log(token);
        // TODO - verify the fcm_token is not set yet, and if already set, verify it is not different
        localStorage.setItem('fcm_token', token);
      }
    } catch (error) {
      console.error("Error generating token:", error);
    }
  } else {
    console.warn("Service Worker not available or messaging is not initialized.");
  }
};

// TODO - verify this funcitonality
export const listenForTokenRefresh = () => {
  messaging.onTokenRefresh(async () => {
    try {
      const newToken = await getToken(messaging, {
        vapidKey: FIREBASE_VAPID_KEY,
      });
      // console.log("New token received:", newToken);

      const storedToken = localStorage.getItem('fcm_token');
      if (newToken !== storedToken) {
        // console.log("Token has changed, updating...");
        localStorage.setItem('fcm_token', newToken);

        // TODO - review this replacement functionality
        // await sendTokenToBackend(newToken, storedToken);
      }
    } catch (error) {
      console.error("Error refreshing token:", error);
    }
  });
};

// listenForTokenRefresh();

export { messaging };
